// ignore-string-externalization
import { marked } from 'marked';
import memoize from 'lodash/memoize';
import { DefaultRenderer } from './DefaultRenderer';
import { ArticleRenderer } from './ArticleRenderer';
export var defaultMarkdown = memoize(function (text) {
  return marked(text, {
    renderer: new DefaultRenderer()
  });
});
export var articleMarkdown = memoize(function (text) {
  var initialDropcap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var renderer = new ArticleRenderer();
  renderer.initialDropcap = initialDropcap; // temporary? Replace manually embedded iframes with the correct
  // widget codes

  var txt = text.replace(/<iframe.* src=".*youtube.com\/embed\/([^"]+)".*><\/iframe>/gi, '[youtube-video $1]').replace(/<iframe.* src=".*open.spotify.com\/embed\/([^"]+)".*><\/iframe>/gi, function (_, p1) {
    return "[play-button spotify:".concat(p1.replace('/', ':'), "]");
  });
  return marked(txt, {
    renderer: renderer
  });
});